import { useEffect } from "react";

const ROBOTS_CONTENT = "noindex, nofollow, noarchive";

/**
 * Evita indexación en buscadores sin bloquear el acceso directo.
 */
export default function AdminNoIndex({ children }) {
  useEffect(() => {
    const names = ["robots", "googlebot", "bingbot"];
    const created = names.map((name) => {
      const el = document.createElement("meta");
      el.name = name;
      el.content = ROBOTS_CONTENT;
      el.setAttribute("data-admin-noindex", "true");
      document.head.appendChild(el);
      return el;
    });

    const prevTitle = document.title;
    document.title = "Admin · Elite Vacances";

    return () => {
      created.forEach((el) => el.remove());
      document.title = prevTitle;
    };
  }, []);

  return children;
}
